export class SlackMessageNotFoundError extends Error {}
